export const selectSelectedCell = (state) => state.selectedCell;
